import { render } from "./CollectionLookCard.vue?vue&type=template&id=52b08dc6&scoped=true"
import script from "./CollectionLookCard.vue?vue&type=script&lang=js"
export * from "./CollectionLookCard.vue?vue&type=script&lang=js"

import "./CollectionLookCard.vue?vue&type=style&index=0&id=52b08dc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b08dc6"]])

export default __exports__